<template>
  <div v-if="data" class="report-view">
    <InterlayerPage
      :disable-count="pageCount"
      :site="site.name"
      section="impact"
      :baseline="site.name"
      :filters="filters"
      class="page"
      :title="$t('sections.impact')"
      :transports="[transportMode]"
      :comment="comment"
      :study-collaborators-count="data.collaboratorsCount"
      :transport-collaborators-count="data.filteredCollaboratorsCount"
    />
    <AnalysisSection :page-count="pageCount + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.impact') }}</h2>
        <h5>{{ $t('report.impactProportion') }}</h5>
      </template>
      <template #body>
        <Proportion :data="data" />
        <div class="proportion-legend">
          <div class="label improvement">
            {{ $t('improvement') }}
          </div>
          <div class="cercle"></div>
          <div class="label degradation">
            {{ $t('degradation') }}
          </div>
        </div>
      </template>
    </AnalysisSection>
    <AnalysisSection v-for="(enumeration, idx) in enumerable()" :key="idx" :page-count="pageCount + idx + 2" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.impact') }}</h2>
        <h5>
          {{ $t('report.impactDetailAnalysis') }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
      </template>
      <template #body>
        <DetailsTable :data="data" :range="enumeration" :forcedTransport="data.transportMode.key" />
      </template>
    </AnalysisSection>
    <AnalysisSection
      v-for="(enumeration, idx) in enumerable()"
      :key="`impact-focus-${idx}`"
      :page-count="pageCount + enumerable().length + idx + 2"
      :filters="filters"
    >
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.impact') }}</h2>
        <h5>
          {{ $t('report.impactFocus') }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
      </template>
      <template #body>
        <FocusDecay :data="data" :range="enumeration" :forcedTransport="data.transportMode.key" />
      </template>
    </AnalysisSection>
  </div>
</template>

<script>
import AnalysisMixin from '@/components/Export/Analysis/Mixin';
import Proportion from '@/components/Analysis/Impact/Proportion';
import DetailsTable from '@/components/Analysis/Impact/DetailsTable';
import FocusDecay from '@/components/Analysis/Impact/FocusDecay';

export default {
  components: {
    Proportion,
    DetailsTable,
    FocusDecay,
  },

  mixins: [AnalysisMixin],
};
</script>
